export const languages = {
  en: {name: 'English', value: 'en'},
};
